import React from "react";
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { Link } from "react-router-dom";
import arrayMove from 'array-move';

export default function ArticleList(props) {

    const [data, setData] = React.useState({ list: [] });

    React.useEffect(() => {
        setData({ list: props.list })
    }, [props.list]);

    function parseTimestamp(unixTimestamp) {
        var date = new Date();

        if (unixTimestamp !== 0) {
            date = new Date(unixTimestamp * 1000);
        }

        return date.toLocaleString()
    }

    const SortableItem = SortableElement(({ article, last }) => (
        <div key={article.id} className="col col-12">
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col">
                            <p>
                            {
                                    article.is_active ?
                                    <span className="badge badge-soft-success text-uppercase mr-2">Active</span>
                                        :
                                        <span className="badge badge-soft-secondary text-uppercase mr-2">Inactive</span>
                                }
                                {
                                    article.is_featured ?
                                        <span className="badge badge-soft-warning text-uppercase mr-2">Featured</span>
                                        :
                                        null
                                }
                               
                            </p>
                        </div>
                        <div className="col-auto">
                            {
                                props.editSorting ?
                                    <button className="btn text-muted"><span className="fe fe-align-justify"></span></button>
                                    :
                                    <Link key={article.id} className="btn btn-light btn-sm" to={`/articles/${article.id}`}>edit</Link>
                            }
                        </div>
                    </div>
                    <div className="row">
                    <div className="col-auto">
                    <img src={article.image_url} alt="" height="40"></img>
                </div>
                        <div className="col">
                            <p className="mb-0 small"><strong>{article.title}</strong></p>
                            <p className="mb-0 small">{article.description}</p>
                        </div>
                    </div>

                    <hr />
                    {
                        article.updated.email ?
                            <p className="card-text small text-muted mb-0">Updated by {article.updated.email} • {parseTimestamp(article.updated.timestamp)}</p>
                            :
                            <p className="card-text small text-muted mb-0">Created by {article.created.email} • {parseTimestamp(article.created.timestamp)}</p>
                    }
                </div>
            </div>
        </div>
    )
    );

    const SortableList = SortableContainer(({ items }) => {
        return (
            <div className="row">
                {items.map((article, index) => (
                    <SortableItem disabled={!props.editSorting} key={`item-${article.id}`} index={index} article={article} last={index === items.length - 1} />
                ))}
            </div>
        );
    });

    const onSortEnd = ({ oldIndex, newIndex }) => {
        let list = data.list;
        list = arrayMove(list, oldIndex, newIndex);
        setData({ list: list });
        props.onSort(list)
    };

    return (
        <div className="">
            <div className="">
                {/* distance={2} is very important as it will make any link in a row clickable */}
                <SortableList distance={2} items={data.list} onSortEnd={onSortEnd}></SortableList>
            </div>
        </div>
    );
}
